const apiUrl: string = process.env.REACT_APP_API_URL || '';
export default apiUrl;